enum AppRoutes {
  Analytics = '/analytics',
  EditParameters = '/productmanager/:productId/editparameters',
  ForgotPassword = '/forgotpassword',
  Home = '/home',
  Landing = '/',
  NewProduct = '/productmanager/newproduct',
  OrderManager = '/ordermanager',
  Product = '/productmanager/:productId',
  ProductManager = '/productmanager',
  RecoverPassword = '/recoverpassword',
  Register = '/register',
  Settings = '/settings',
  SettingsSection = '/settings/:section',
  Unsubscribe = '/unsubscribe',
}

export default AppRoutes;
